import {createPopperLite as createPopper, preventOverflow, flip} from '@popperjs/core';

const targetSection = document.querySelector('.js-citationWidget');

class RangeReference {
    constructor() {
        this.updateRect();
        const update = () => {
            let selection = document.getSelection();
            this.range = selection && selection.rangeCount && selection.getRangeAt(0);
            this.updateRect(selection);
        };

        window.addEventListener('scroll', update);
        document.addEventListener('selectionchange', update);
    }

    /**
     * @param {Selection} selection
     * @returns {void}
     */
    updateRect(selection) {
        if (
            this.range
            && targetSection.contains(selection.getRangeAt(0).startContainer)
            && targetSection.contains(selection.getRangeAt(0).endContainer)
        ) {
            this.rect = this.range.getBoundingClientRect();
        } else {
            this.rect = {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: 0,
                height: 0,
            };
        }

        this.rectChangedCallback(this.rect);
    }

    rectChangedCallback({width}) {
        if (width > 1) {
            popper?.update();
            pop.classList.remove('hidden');
            pop.firstElementChild.classList.add('pop__popper--visible');
        } else {
            pop.classList.add('hidden');
            pop.firstElementChild.classList.remove('pop__popper--visible');
        }
    }

    getBoundingClientRect() {
        return this.rect;
    }
}

/** Create a new instance of Popper */
const pop = document.querySelector('.js-pop');

let popper;

if (targetSection instanceof HTMLElement) {
    const rangeReference = new RangeReference();
    popper = createPopper(rangeReference, pop, {
        placement: 'top',
        modifiers: [
            preventOverflow,
            flip,
            {
                name: 'offset',
                options: {
                    offset: [0, 12],
                },
            },
        ],
    });
}
